angular.module('core')
    .service("uiSelectFix", function () {
        this.multipleSelectedFilter = function (selected, property) {
            return function (item) {
                if (angular.isUndefined(selected))
                    return true;
                if (angular.isUndefined(item)) {
                    return false;
                }
                var allIds = selected.map(function (item) {
                    return item[property];
                });
                return allIds.indexOf(item[property]) < 0;
            }
        };
    })
